import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-contents" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_5 = { class: "x_panel" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NotificationHistoryVue = _resolveComponent("NotificationHistoryVue");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "form-details" }, [
            _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tNotifications\r\n\t\t\t\t")
            ])
        ], -1 /* CACHED */)),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_NotificationHistoryVue, { showSummary: true })
                    ])
                ])
            ])
        ])
    ]));
}
